import type { RouteRecordRaw } from 'vue-router';
import gettext from 'src/utils/gettext';

const { $gettext } = gettext;

export const printRoutes: RouteRecordRaw[] = [
  {
    path: 'card/:patientId',
    alias: $gettext('karta/:patientId'),
    name: 'print-patient',
    props: (route) => ({
      patientId: route.params.patientId,
      selectedVisitsIds: route.query.selectedVisitsIds,
      visitsToDate: route.query.visitsToDate,
    }),
    component: () => import('src/pages/print/PrintPatient.vue'),
  },
  {
    path: 'visit/:patientId/:visitId',
    alias: $gettext('navsteva/:patientId/:visitId'),
    name: 'print-visit',
    props: true,
    component: () => import('pages/print/PrintVisit.vue'),
  },
  {
    path: 'visits-confirmation/:patientId',
    alias: $gettext('potvrzeni-pece/:patientId'),
    name: 'print-visits-confirmation',
    props: (route) => ({
      patientId: route.params.patientId,
      visits: route.query.visits,
    }),
    component: () => import('pages/print/PrintVisitConfirmation.vue'),
  },
];
